import { Link } from "react-router-dom";
import Container from "../components/layout/Container";
import PageHeader from "../components/layout/PageHeader";
import { about, aboutLinks } from "../data/site";

export default function AboutPage() {
  return (
    <>
      <PageHeader title="About" lede={about.lead} />
      <Container className="pb-24">
        <p className="max-w-2xl text-lg leading-relaxed text-[var(--text)]">{about.detail}</p>
        <p className="mt-5 max-w-2xl leading-relaxed text-[var(--muted)]">
          Company detail, technical work, projects, chess, and MobilTech each have their own page.
        </p>

        <div className="mt-16">
          <h2 className="kicker">Continue</h2>
          <ul className="mt-4 border-y border-[var(--line)]">
          {aboutLinks.map((link) => (
            <li key={link.href} className="hover-cell border-b border-[var(--line)] last:border-b-0">
              <Link
                to={link.href}
                className="group flex flex-col gap-1 px-3 py-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8"
              >
                <span className="font-medium text-[var(--ink)] transition-colors group-hover:text-[var(--accent)]">
                  {link.label}
                </span>
                <span className="text-sm text-[var(--muted)]">{link.note}</span>
              </Link>
            </li>
          ))}
          </ul>
        </div>
      </Container>
    </>
  );
}
